import React, { Children, useCallback, useEffect } from 'react';

import { useTransition, animated } from '@react-spring/web';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useStepper } from '../../utils/stepper';

const DEFAULT_TRANSITION_CONFIG = {
  from: { opacity: 0 },
  enter: { opacity: 1 },
  leave: { opacity: 0 },
  delay: 200,
  config: { duration: 500 },
  exitBeforeEnter: true,
};

const StepperWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const StepWrapper = styled.div``;

const Stepper = ({ children, className }) => (
  <StepperWrapper className={className}>{children}</StepperWrapper>
);

const StepperStep = ({ children, className }) => (
  <StepWrapper className={className}>{children}</StepWrapper>
);

const AnimatedDiv = styled(animated.div)``;

const StepperSteps = ({
  children,
  transitionConfig = DEFAULT_TRANSITION_CONFIG,
}) => {
  const { currentStep, setSteps, steps } = useStepper();
  const transitions = useTransition(currentStep, transitionConfig);

  const createSteps = useCallback(() => {
    const stepperSteps = Children.toArray(children)
      .filter(step => !!step.props.id && !step.props.skip)
      .map(step => step.props);

    return setSteps(stepperSteps);
  }, [setSteps, children]);

  useEffect(() => {
    createSteps();
  }, []);

  return steps.length
    ? transitions((style, index) => {
        return Children.toArray(children)
          .filter(child => !child.props.skip)
          .map(child => {
            return child.props.id === steps[index].id ? (
              <AnimatedDiv
                style={style}
                data-testid={steps[index].id}
                key={steps[index].id}
              >
                {child}
              </AnimatedDiv>
            ) : null;
          });
      })
    : null;
};

Stepper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
};

StepperSteps.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  transitionConfig: PropTypes.object,
};

StepperStep.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
};

Stepper.Steps = StepperSteps;
Stepper.Step = StepperStep;

export default Stepper;
